var path = 'ng-templates/sceneCrosshair.html';
var html = "<svg height=\"20\" width=\"20\" ng-style=\"style\" style=\"position: fixed;z-index: 2000;pointer-events:none;\">\n    <line x1=\"0\" y1=\"10\" x2=\"8\" y2=\"10\" style=\"stroke:inherit;stroke-width:2;\"></line>\n    <line x1=\"12\" y1=\"10\" x2=\"12\" y2=\"10\" style=\"stroke:inherit;stroke-width:2;\"></line>\n    <line x1=\"10\" y1=\"0\" x2=\"10\" y2=\"8\" style=\"stroke:inherit;stroke-width:2;\"></line>\n    <line x1=\"10\" y1=\"12\" x2=\"10\" y2=\"20\" style=\"stroke:inherit;stroke-width:2;\"></line>\n    <polygon points=\"0,9 0,12 9,12 9,20 12,20 12,12 20,12 20,9 12,9 12,0 9,0 9,9\" style=\"fill: white;stroke:black;stroke-width: 2;\"></polygon>\n</svg>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/ng-templates/sceneCrosshair.html
// module id = 262
// module chunks = 0